//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Returns list of all studies for Admin according to the search query.
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getAdminStudies(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfAdminStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/listForAdmin?";
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (withFailedToken !== undefined && withFailedToken !== null)
        url_ += "WithFailedToken=" + encodeURIComponent("" + withFailedToken) + "&";
    if (isClosed !== undefined && isClosed !== null)
        url_ += "IsClosed=" + encodeURIComponent("" + isClosed) + "&";
    if (hasEcrf !== undefined && hasEcrf !== null)
        url_ += "HasEcrf=" + encodeURIComponent("" + hasEcrf) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetAdminStudies,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetAdminStudies(_response);
    });
}

function processGetAdminStudies(response: AxiosResponse): Promise<Types.PagedResultOfAdminStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfAdminStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfAdminStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfAdminStudyDto>(null as any);
}

/**
 * Returns doctor's studies
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getDoctorStudies(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorStudyListDto> {
    let url_ = getBaseUrl() + "/api/studies/listForDoctor?";
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (withFailedToken !== undefined && withFailedToken !== null)
        url_ += "WithFailedToken=" + encodeURIComponent("" + withFailedToken) + "&";
    if (isClosed !== undefined && isClosed !== null)
        url_ += "IsClosed=" + encodeURIComponent("" + isClosed) + "&";
    if (hasEcrf !== undefined && hasEcrf !== null)
        url_ += "HasEcrf=" + encodeURIComponent("" + hasEcrf) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDoctorStudies,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDoctorStudies(_response);
    });
}

function processGetDoctorStudies(response: AxiosResponse): Promise<Types.DoctorStudyListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DoctorStudyListDto.fromJS(resultData200);
        return Promise.resolve<Types.DoctorStudyListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorStudyListDto>(null as any);
}

/**
 * Return study info for a logged in doctor.
 * @param id Study Id
 */
export function getDoctorStudyById(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/{id}/forDoctor";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDoctorStudyById,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDoctorStudyById(_response);
    });
}

function processGetDoctorStudyById(response: AxiosResponse): Promise<Types.DoctorStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DoctorStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.DoctorStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorStudyDto>(null as any);
}

/**
 * Get all files attached to the study
 * @param studyId Id of the study
 */
export function getStudyAttachments(studyId: number, config?: AxiosRequestConfig | undefined): Promise<Types.StudyAttachmentDto[]> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/attachments";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyAttachments,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyAttachments(_response);
    });
}

function processGetStudyAttachments(response: AxiosResponse): Promise<Types.StudyAttachmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.StudyAttachmentDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.StudyAttachmentDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyAttachmentDto[]>(null as any);
}

/**
 * Add attachment to the study
 * @param studyId Id of the study
 * @param attachments (optional) 
 */
export function addAttachmentToStudy(studyId: number, attachments?: Types.FileParameter[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.StudyAttachmentDto[]> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/attachments";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (attachments !== null && attachments !== undefined)
        attachments.forEach(item_ => content_.append("attachments", item_.data, item_.fileName ? item_.fileName : "attachments") );

    let options_: AxiosRequestConfig = {
        ..._requestConfigAddAttachmentToStudy,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processAddAttachmentToStudy(_response);
    });
}

function processAddAttachmentToStudy(response: AxiosResponse): Promise<Types.StudyAttachmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.StudyAttachmentDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.StudyAttachmentDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyAttachmentDto[]>(null as any);
}

/**
 * Remove attachment from the study
 * @param studyId Id of the study
 * @param attachmentId Id of the attachment
 */
export function removeAttachmentFromStudy(studyId: number, attachmentId: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/attachments/{attachmentId}";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (attachmentId === undefined || attachmentId === null)
      throw new Error("The parameter 'attachmentId' must be defined.");
    url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveAttachmentFromStudy,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveAttachmentFromStudy(_response);
    });
}

function processRemoveAttachmentFromStudy(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sync PrismaCloud data for given study in background.
 */
export function syncStudyData(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/sync/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSyncStudyData,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSyncStudyData(_response);
    });
}

function processSyncStudyData(response: AxiosResponse): Promise<Types.DoctorStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DoctorStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.DoctorStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorStudyDto>(null as any);
}

/**
 * Sync PrismaCloud data for given study in background by Admin.
 */
export function syncStudyDataByAdmin(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studies/sync/{id}/byAdmin";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigSyncStudyDataByAdmin,
        ...config,
        method: "POST",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSyncStudyDataByAdmin(_response);
    });
}

function processSyncStudyDataByAdmin(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Sync PrismaCloud data for given study in background by Admin.
 */
export function isStudySyncInProgress(id: number, config?: AxiosRequestConfig | undefined): Promise<boolean> {
    let url_ = getBaseUrl() + "/api/studies/sync/{id}/ping";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigIsStudySyncInProgress,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processIsStudySyncInProgress(_response);
    });
}

function processIsStudySyncInProgress(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
        return Promise.resolve<boolean>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
}

/**
 * Return study for the logged in patient.
 */
export function getMyStudy(config?: AxiosRequestConfig | undefined): Promise<Types.PatientStudyDto> {
    let url_ = getBaseUrl() + "/api/studies";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMyStudy,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMyStudy(_response);
    });
}

function processGetMyStudy(response: AxiosResponse): Promise<Types.PatientStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientStudyDto>(null as any);
}

/**
 * Creates a study and assigns it to the current user (Doctor).
 * @param newStudy Request parameter
 */
export function createStudy(newStudy: Types.CreateStudyDto, config?: AxiosRequestConfig | undefined): Promise<Types.AdminStudyDto> {
    let url_ = getBaseUrl() + "/api/studies";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(newStudy);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateStudy,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateStudy(_response);
    });
}

function processCreateStudy(response: AxiosResponse): Promise<Types.AdminStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AdminStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.AdminStudyDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.AdminStudyDto.fromJS(resultData201);
        return Promise.resolve<Types.AdminStudyDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AdminStudyDto>(null as any);
}

/**
 * Return study for the logged in patient.
 */
export function getMyStudy2(config?: AxiosRequestConfig | undefined): Promise<Types.PatientStudyDto> {
    let url_ = getBaseUrl() + "/api/study";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetMyStudy2,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetMyStudy2(_response);
    });
}

function processGetMyStudy2(response: AxiosResponse): Promise<Types.PatientStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PatientStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.PatientStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientStudyDto>(null as any);
}

/**
 * Creates new patient group in the study.
 * @param dto DTO with arguments.
 */
export function createGroup(studyId: number, dto: Types.CreateGroupDto, config?: AxiosRequestConfig | undefined): Promise<Types.GroupDto> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/groups";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateGroup,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateGroup(_response);
    });
}

function processCreateGroup(response: AxiosResponse): Promise<Types.GroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GroupDto.fromJS(resultData200);
        return Promise.resolve<Types.GroupDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GroupDto>(null as any);
}

/**
 * Updates visibility of columns on dashboard for the specific group.
 * @param id Id of the group.
 * @param dto DTO with new columns values.
 */
export function updateGroupConfiguration(id: number, dto: Types.UpdateGroupDto, config?: AxiosRequestConfig | undefined): Promise<Types.GroupDto> {
    let url_ = getBaseUrl() + "/api/studies/groups/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateGroupConfiguration,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateGroupConfiguration(_response);
    });
}

function processUpdateGroupConfiguration(response: AxiosResponse): Promise<Types.GroupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.GroupDto.fromJS(resultData200);
        return Promise.resolve<Types.GroupDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.GroupDto>(null as any);
}

/**
 * Remove the group
 * @param id Id of the group.
 */
export function removeGroup(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/studies/groups/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveGroup,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveGroup(_response);
    });
}

function processRemoveGroup(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Updates some study settings.
 * @param id Study to update.
 * @param dto DTO with new values.
 */
export function updateSettings(id: number, dto: Types.PatchStudyDto, config?: AxiosRequestConfig | undefined): Promise<Types.AdminStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateSettings,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateSettings(_response);
    });
}

function processUpdateSettings(response: AxiosResponse): Promise<Types.AdminStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AdminStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.AdminStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AdminStudyDto>(null as any);
}

export function updateStudyInfoPageConfiguration(studyId: number, dto?: Types.StudyInfoPageConfigurationDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.AdminStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/infoPageConfiguration";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateStudyInfoPageConfiguration,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateStudyInfoPageConfiguration(_response);
    });
}

function processUpdateStudyInfoPageConfiguration(response: AxiosResponse): Promise<Types.AdminStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AdminStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.AdminStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AdminStudyDto>(null as any);
}

/**
 * Updates only prisma cloud client settings.
 * @param id Study to update.
 * @param dto DTO with new values.
 */
export function updatePrismaClientSettings(id: number, dto: Types.UpdatePrismaClientDto, config?: AxiosRequestConfig | undefined): Promise<Types.AdminStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/{id}/client";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdatePrismaClientSettings,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdatePrismaClientSettings(_response);
    });
}

function processUpdatePrismaClientSettings(response: AxiosResponse): Promise<Types.AdminStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.AdminStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.AdminStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.AdminStudyDto>(null as any);
}

/**
 * Approve closing the study
 * @param id Study to approve closing
 */
export function approveClosureStudy(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/{id}/approveClosure";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigApproveClosureStudy,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processApproveClosureStudy(_response);
    });
}

function processApproveClosureStudy(response: AxiosResponse): Promise<Types.DoctorStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DoctorStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.DoctorStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorStudyDto>(null as any);
}

/**
 * Revoke of closure approval the study
 * @param id Study to revoke of closure approval
 */
export function revokeClosureApprovalStudy(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/{id}/revokeClosureApproval";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRevokeClosureApprovalStudy,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRevokeClosureApprovalStudy(_response);
    });
}

function processRevokeClosureApprovalStudy(response: AxiosResponse): Promise<Types.DoctorStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DoctorStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.DoctorStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorStudyDto>(null as any);
}

/**
 * Close the study
 * @param id Study to approve closing
 */
export function closeStudy(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorStudyDto> {
    let url_ = getBaseUrl() + "/api/studies/{id}/closeStudy";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigCloseStudy,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCloseStudy(_response);
    });
}

function processCloseStudy(response: AxiosResponse): Promise<Types.DoctorStudyDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.DoctorStudyDto.fromJS(resultData200);
        return Promise.resolve<Types.DoctorStudyDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorStudyDto>(null as any);
}

/**
 * Get recruitment progress of the study
 * @param studyId Study to get recruitment progress
 */
export function getRecruitmentProgress(studyId: number, config?: AxiosRequestConfig | undefined): Promise<Types.StudyRecruitmentProgressDto> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/recruitmentProgress";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetRecruitmentProgress,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetRecruitmentProgress(_response);
    });
}

function processGetRecruitmentProgress(response: AxiosResponse): Promise<Types.StudyRecruitmentProgressDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.StudyRecruitmentProgressDto.fromJS(resultData200);
        return Promise.resolve<Types.StudyRecruitmentProgressDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyRecruitmentProgressDto>(null as any);
}

/**
 * Get summary of patients in the study for dashboard.
Summary includes count of patients in each group and count of patients in each study state
(e.g. active, dropped out etc.).
 */
export function getPatientsSummary(studyId: number, config?: AxiosRequestConfig | undefined): Promise<Types.PatientGroupSummaryDto[]> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/patientsSummary";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetPatientsSummary,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetPatientsSummary(_response);
    });
}

function processGetPatientsSummary(response: AxiosResponse): Promise<Types.PatientGroupSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.PatientGroupSummaryDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.PatientGroupSummaryDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PatientGroupSummaryDto[]>(null as any);
}

/**
 * Get list of study users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) User role
 * @param favoriteUserIds (optional) List of favorite users
 * @param tags (optional) User's tags
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Sorting criteria.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getStudyUserList(studyId: number, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, favoriteUserIds?: string[] | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: Types.StaffSorting | null | undefined, sortOrder?: Types.SortOrder | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfStudyStaffDto> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/users?";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (roles !== undefined && roles !== null)
        roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
    if (favoriteUserIds !== undefined && favoriteUserIds !== null)
        favoriteUserIds && favoriteUserIds.forEach(item => { url_ += "FavoriteUserIds=" + encodeURIComponent("" + item) + "&"; });
    if (tags !== undefined && tags !== null)
    {
        const content_ = JSON.stringify(tags);
        url_ += "Tags=" + encodeURIComponent(content_) + "&";
    }
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder !== undefined && sortOrder !== null)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyUserList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyUserList(_response);
    });
}

function processGetStudyUserList(response: AxiosResponse): Promise<Types.PagedResultOfStudyStaffDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfStudyStaffDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfStudyStaffDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfStudyStaffDto>(null as any);
}

/**
 * Get tags of the study users and tags of patients that are visible for the user according to his tags.
 * @param studyId Study ID
 */
export function getStudyStaffTags(studyId: number, config?: AxiosRequestConfig | undefined): Promise<{ [key: string]: string[]; }> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/userTags";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyStaffTags,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyStaffTags(_response);
    });
}

function processGetStudyStaffTags(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.TagFiltersDto.fromJS(resultData200);
        return Promise.resolve<{ [key: string]: string[]; }>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<{ [key: string]: string[]; }>(null as any);
}

/**
 * This method used to get all tags of the study users and patients for admin.
 */
export function getStudyAllTags(studyId: number, config?: AxiosRequestConfig | undefined): Promise<{ [key: string]: string[]; }> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/allTags";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyAllTags,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyAllTags(_response);
    });
}

function processGetStudyAllTags(response: AxiosResponse): Promise<{ [key: string]: string[]; }> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.TagFiltersDto.fromJS(resultData200);
        return Promise.resolve<{ [key: string]: string[]; }>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<{ [key: string]: string[]; }>(null as any);
}

/**
 * Get study users per role
 */
export function getStudyStaffPerRole(studyId: number, config?: AxiosRequestConfig | undefined): Promise<Types.StudyStaffPerRoleDto[]> {
    let url_ = getBaseUrl() + "/api/studies/{studyId}/usersPerRole";
    if (studyId === undefined || studyId === null)
      throw new Error("The parameter 'studyId' must be defined.");
    url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetStudyStaffPerRole,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetStudyStaffPerRole(_response);
    });
}

function processGetStudyStaffPerRole(response: AxiosResponse): Promise<Types.StudyStaffPerRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(Types.StudyStaffPerRoleDto.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<Types.StudyStaffPerRoleDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.StudyStaffPerRoleDto[]>(null as any);
}
let _requestConfigGetAdminStudies: Partial<AxiosRequestConfig> | null;
export function getGetAdminStudiesRequestConfig() {
  return _requestConfigGetAdminStudies;
}
export function setGetAdminStudiesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetAdminStudies = value;
}
export function patchGetAdminStudiesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetAdminStudies = patch(_requestConfigGetAdminStudies ?? {});
}

let _requestConfigGetDoctorStudies: Partial<AxiosRequestConfig> | null;
export function getGetDoctorStudiesRequestConfig() {
  return _requestConfigGetDoctorStudies;
}
export function setGetDoctorStudiesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctorStudies = value;
}
export function patchGetDoctorStudiesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctorStudies = patch(_requestConfigGetDoctorStudies ?? {});
}

let _requestConfigGetDoctorStudyById: Partial<AxiosRequestConfig> | null;
export function getGetDoctorStudyByIdRequestConfig() {
  return _requestConfigGetDoctorStudyById;
}
export function setGetDoctorStudyByIdRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctorStudyById = value;
}
export function patchGetDoctorStudyByIdRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctorStudyById = patch(_requestConfigGetDoctorStudyById ?? {});
}

let _requestConfigGetStudyAttachments: Partial<AxiosRequestConfig> | null;
export function getGetStudyAttachmentsRequestConfig() {
  return _requestConfigGetStudyAttachments;
}
export function setGetStudyAttachmentsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyAttachments = value;
}
export function patchGetStudyAttachmentsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyAttachments = patch(_requestConfigGetStudyAttachments ?? {});
}

let _requestConfigAddAttachmentToStudy: Partial<AxiosRequestConfig> | null;
export function getAddAttachmentToStudyRequestConfig() {
  return _requestConfigAddAttachmentToStudy;
}
export function setAddAttachmentToStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigAddAttachmentToStudy = value;
}
export function patchAddAttachmentToStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigAddAttachmentToStudy = patch(_requestConfigAddAttachmentToStudy ?? {});
}

let _requestConfigRemoveAttachmentFromStudy: Partial<AxiosRequestConfig> | null;
export function getRemoveAttachmentFromStudyRequestConfig() {
  return _requestConfigRemoveAttachmentFromStudy;
}
export function setRemoveAttachmentFromStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveAttachmentFromStudy = value;
}
export function patchRemoveAttachmentFromStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveAttachmentFromStudy = patch(_requestConfigRemoveAttachmentFromStudy ?? {});
}

let _requestConfigSyncStudyData: Partial<AxiosRequestConfig> | null;
export function getSyncStudyDataRequestConfig() {
  return _requestConfigSyncStudyData;
}
export function setSyncStudyDataRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSyncStudyData = value;
}
export function patchSyncStudyDataRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSyncStudyData = patch(_requestConfigSyncStudyData ?? {});
}

let _requestConfigSyncStudyDataByAdmin: Partial<AxiosRequestConfig> | null;
export function getSyncStudyDataByAdminRequestConfig() {
  return _requestConfigSyncStudyDataByAdmin;
}
export function setSyncStudyDataByAdminRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSyncStudyDataByAdmin = value;
}
export function patchSyncStudyDataByAdminRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSyncStudyDataByAdmin = patch(_requestConfigSyncStudyDataByAdmin ?? {});
}

let _requestConfigIsStudySyncInProgress: Partial<AxiosRequestConfig> | null;
export function getIsStudySyncInProgressRequestConfig() {
  return _requestConfigIsStudySyncInProgress;
}
export function setIsStudySyncInProgressRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigIsStudySyncInProgress = value;
}
export function patchIsStudySyncInProgressRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigIsStudySyncInProgress = patch(_requestConfigIsStudySyncInProgress ?? {});
}

let _requestConfigGetMyStudy: Partial<AxiosRequestConfig> | null;
export function getGetMyStudyRequestConfig() {
  return _requestConfigGetMyStudy;
}
export function setGetMyStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMyStudy = value;
}
export function patchGetMyStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMyStudy = patch(_requestConfigGetMyStudy ?? {});
}

let _requestConfigCreateStudy: Partial<AxiosRequestConfig> | null;
export function getCreateStudyRequestConfig() {
  return _requestConfigCreateStudy;
}
export function setCreateStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudy = value;
}
export function patchCreateStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateStudy = patch(_requestConfigCreateStudy ?? {});
}

let _requestConfigGetMyStudy2: Partial<AxiosRequestConfig> | null;
export function getGetMyStudy2RequestConfig() {
  return _requestConfigGetMyStudy2;
}
export function setGetMyStudy2RequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetMyStudy2 = value;
}
export function patchGetMyStudy2RequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetMyStudy2 = patch(_requestConfigGetMyStudy2 ?? {});
}

let _requestConfigCreateGroup: Partial<AxiosRequestConfig> | null;
export function getCreateGroupRequestConfig() {
  return _requestConfigCreateGroup;
}
export function setCreateGroupRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateGroup = value;
}
export function patchCreateGroupRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateGroup = patch(_requestConfigCreateGroup ?? {});
}

let _requestConfigUpdateGroupConfiguration: Partial<AxiosRequestConfig> | null;
export function getUpdateGroupConfigurationRequestConfig() {
  return _requestConfigUpdateGroupConfiguration;
}
export function setUpdateGroupConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateGroupConfiguration = value;
}
export function patchUpdateGroupConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateGroupConfiguration = patch(_requestConfigUpdateGroupConfiguration ?? {});
}

let _requestConfigRemoveGroup: Partial<AxiosRequestConfig> | null;
export function getRemoveGroupRequestConfig() {
  return _requestConfigRemoveGroup;
}
export function setRemoveGroupRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveGroup = value;
}
export function patchRemoveGroupRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveGroup = patch(_requestConfigRemoveGroup ?? {});
}

let _requestConfigUpdateSettings: Partial<AxiosRequestConfig> | null;
export function getUpdateSettingsRequestConfig() {
  return _requestConfigUpdateSettings;
}
export function setUpdateSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSettings = value;
}
export function patchUpdateSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateSettings = patch(_requestConfigUpdateSettings ?? {});
}

let _requestConfigUpdateStudyInfoPageConfiguration: Partial<AxiosRequestConfig> | null;
export function getUpdateStudyInfoPageConfigurationRequestConfig() {
  return _requestConfigUpdateStudyInfoPageConfiguration;
}
export function setUpdateStudyInfoPageConfigurationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateStudyInfoPageConfiguration = value;
}
export function patchUpdateStudyInfoPageConfigurationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateStudyInfoPageConfiguration = patch(_requestConfigUpdateStudyInfoPageConfiguration ?? {});
}

let _requestConfigUpdatePrismaClientSettings: Partial<AxiosRequestConfig> | null;
export function getUpdatePrismaClientSettingsRequestConfig() {
  return _requestConfigUpdatePrismaClientSettings;
}
export function setUpdatePrismaClientSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdatePrismaClientSettings = value;
}
export function patchUpdatePrismaClientSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdatePrismaClientSettings = patch(_requestConfigUpdatePrismaClientSettings ?? {});
}

let _requestConfigApproveClosureStudy: Partial<AxiosRequestConfig> | null;
export function getApproveClosureStudyRequestConfig() {
  return _requestConfigApproveClosureStudy;
}
export function setApproveClosureStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigApproveClosureStudy = value;
}
export function patchApproveClosureStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigApproveClosureStudy = patch(_requestConfigApproveClosureStudy ?? {});
}

let _requestConfigRevokeClosureApprovalStudy: Partial<AxiosRequestConfig> | null;
export function getRevokeClosureApprovalStudyRequestConfig() {
  return _requestConfigRevokeClosureApprovalStudy;
}
export function setRevokeClosureApprovalStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRevokeClosureApprovalStudy = value;
}
export function patchRevokeClosureApprovalStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRevokeClosureApprovalStudy = patch(_requestConfigRevokeClosureApprovalStudy ?? {});
}

let _requestConfigCloseStudy: Partial<AxiosRequestConfig> | null;
export function getCloseStudyRequestConfig() {
  return _requestConfigCloseStudy;
}
export function setCloseStudyRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCloseStudy = value;
}
export function patchCloseStudyRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCloseStudy = patch(_requestConfigCloseStudy ?? {});
}

let _requestConfigGetRecruitmentProgress: Partial<AxiosRequestConfig> | null;
export function getGetRecruitmentProgressRequestConfig() {
  return _requestConfigGetRecruitmentProgress;
}
export function setGetRecruitmentProgressRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetRecruitmentProgress = value;
}
export function patchGetRecruitmentProgressRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetRecruitmentProgress = patch(_requestConfigGetRecruitmentProgress ?? {});
}

let _requestConfigGetPatientsSummary: Partial<AxiosRequestConfig> | null;
export function getGetPatientsSummaryRequestConfig() {
  return _requestConfigGetPatientsSummary;
}
export function setGetPatientsSummaryRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientsSummary = value;
}
export function patchGetPatientsSummaryRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetPatientsSummary = patch(_requestConfigGetPatientsSummary ?? {});
}

let _requestConfigGetStudyUserList: Partial<AxiosRequestConfig> | null;
export function getGetStudyUserListRequestConfig() {
  return _requestConfigGetStudyUserList;
}
export function setGetStudyUserListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyUserList = value;
}
export function patchGetStudyUserListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyUserList = patch(_requestConfigGetStudyUserList ?? {});
}

let _requestConfigGetStudyStaffTags: Partial<AxiosRequestConfig> | null;
export function getGetStudyStaffTagsRequestConfig() {
  return _requestConfigGetStudyStaffTags;
}
export function setGetStudyStaffTagsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyStaffTags = value;
}
export function patchGetStudyStaffTagsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyStaffTags = patch(_requestConfigGetStudyStaffTags ?? {});
}

let _requestConfigGetStudyAllTags: Partial<AxiosRequestConfig> | null;
export function getGetStudyAllTagsRequestConfig() {
  return _requestConfigGetStudyAllTags;
}
export function setGetStudyAllTagsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyAllTags = value;
}
export function patchGetStudyAllTagsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyAllTags = patch(_requestConfigGetStudyAllTags ?? {});
}

let _requestConfigGetStudyStaffPerRole: Partial<AxiosRequestConfig> | null;
export function getGetStudyStaffPerRoleRequestConfig() {
  return _requestConfigGetStudyStaffPerRole;
}
export function setGetStudyStaffPerRoleRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyStaffPerRole = value;
}
export function patchGetStudyStaffPerRoleRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetStudyStaffPerRole = patch(_requestConfigGetStudyStaffPerRole ?? {});
}